import { METHOD } from "./method";

export const API_CONTRACT_IMPORT = {
    DOWNLOAD_TEMPLATE: {
        api: '/v1/hr-adm/contract/import/download-template',
        method: METHOD.GET
    },
    IMPORT_VALIDATION: {
        api: '/v1/hr-adm/contract/import/validate',
        method: METHOD.POST
    },
    IMPORT: {
        api: '/v1/hr-adm/contract/import',
        method: METHOD.POST
    },
}
